var MARKER_DELIMITER = ';base64,';
export function encodeFile(file) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var withoutMarker = options.withoutMarker;
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      var result = reader.result;
      if (withoutMarker) {
        result = result.split(MARKER_DELIMITER)[1] || result;
      }
      resolve(result);
    };
    reader.onerror = function (error) {
      return reject(error);
    };
  });
}